<template>
    <div>
        <list-container :header="translate('navigation.myJobs')" v-show="!$route.params.id">
            <template v-slot:commands>
                <excel-exporter table-id="myJobsExport" :columns="columns" url="/job/get" modelName="JobMy" :listType="baseFilterObject.ListType"></excel-exporter>
                <button  v-if="hasAuth('Draft')" class="btn btn-primary float-right" @click="$router.push({ name:'DraftDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('draft.newJob')}}
                </button>
            </template>
            <div class="rbcontent">
                <form @submit.prevent="applyFilter()">
                    <div class="row">
                        <div class="col-2">
                            <label>{{translate('reportFilter.trackingNo')}}</label>
                            <div class="input-group input-group-sm mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">{{$route.params.accountCode.toUpperCase()}}</span>
                                </div>
                                <input type="number" v-model="filterForm.Number" class="form-control form-control-sm" placeholder="No">
                            </div>
                        </div>
                        <div class="col-3">
                            <label>{{translate('reportFilter.jobName')}}</label>
                            <input type="text" @input="checkInput('Title',$event)" v-model="filterForm.Title" class="form-control form-control-sm" >
                        </div>
                        <div class="col-3">
                            <label>{{translate('jobList.list')}}</label>
                            <select class="form-control form-control-sm" v-model="baseFilterObject.ListType">
                                <option v-for="(item, key) in listTypes" :key="key" :value="key" v-show="item.isVisible == false ? false : true">
                                    {{item.text}}
                                </option>
                            </select>
                        </div>
                        <div class="col-2">
                            <label>{{translate('jobFinalizer.state')}}</label>
                            <select class="form-control form-control-sm" v-model="filterForm.State">
                                <option :value="null">{{translate('incomingDocFilter.all')}}</option>
                                <option v-for="(item, key) in $izonay.jobStatus" :key="key" :value="key">
                                    {{item.text}}
                                </option>
                            </select>
                        </div>
                        <div class="col-2">
                            <button style="margin-top:30px;" type="submit" class="btn btn-sm btn-primary">{{translate('jobList.applyFilter')}}</button>
                        </div>
                    </div>
                </form>
            </div>
            <list ref="jobList" :columns="columns" url="/job/get" modelName="JobMy" :hideDeleteCommand="hideDeleteCommand" :filter="baseFilterObject"  :predicate="predicate">

            </list>
        </list-container>
        <router-view v-if="$route.params.id" :key="$route.params.id"/>
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import i18n from '../i18n'

import ExcelExporter from '../components/ExcelExporter.vue';
export default {
    components: {
        list,
        listContainer,
        ExcelExporter
    },
    created(){
        console.log('FİLTER:', this.baseFilterObject);
    },
    computed: {
        listTypes(){
            var fnHasModule = this.hasModule;
            return {
                MyAll: { text: this.translate('jobMyList.myAll') },
                MyOwned: {text: this.translate('jobMyList.myOwned') },
                MyWaiting: { text: this.translate('jobMyList.myWaiting') },
                MyApproved: { text: this.translate('jobMyList.myApproved') },
                MyAllRem: { 
                    text: this.translate('jobMyList.myAllRem'),
                    isVisible : fnHasModule('REM')
                },
                MyDeclined: { text: this.translate('jobMyList.myDeclined') },
                MyCanceled: { text: this.translate('jobMyList.myCancelled') },
            }
        }
    },
    data(){
        return {
            user: null,
            filterForm: { State:null },
            baseFilterObject: { ListType : window.location.hash?.replace('#', '') || 'MyWaiting' }, 
            hideDeleteCommand:true,
            predicate: "",            
            columns : [
                {
                    Key: "TrackingNo",
                    Title: this.translate('reportFilter.trackingNo'),
                    SortField: "TrackingNo.Number",
                    Content(i) {
                        return Vue.filter('trackingNo')(i.TrackingNo);
                    }
                },
                {
                    Key: "Title",
                    Title: this.translate('reportFilter.jobName'),
                    SortField: "Title"
                },
                {
                    Key: "Owner",
                    Title: this.translate('reportFilter.starter'),
                    //SortField: "Owner.Fl, Owner.LastName",
                    Content(i) {
                        return `${Vue.filter('stripHTML')(i.Owner.FirstName)} ${Vue.filter('stripHTML')(i.Owner.LastName)}`
                }
                },                
                {
                    Key: "Progress",
                    Title: this.translate('jobList.progess'),
                    Content(i) {
                        return `${i.CompletedStepCount} / ${i.TotalStepCount}`
                    }
                },
                {
                    Key: "Waiting",
                    Title: this.translate('jobList.waiting'),
                    Content(i) {
                        var currentStep = i.CurrentStep;
                        var result = '';

                        if(currentStep) {
                            for(var c = 0; c < currentStep.WaitingUsers.length; c++) {
                                result += Vue.filter('stripHTML')(currentStep.WaitingUsers[c].FullName)
                                if(c < currentStep.WaitingUsers.length - 2) {
                                    result += ', ';
                                } else if(c < currentStep.WaitingUsers.length - 1) {
                                    result += currentStep.Condition == 'All' ? i18n.t('jobList.and') : i18n.t('jobList.or'); 
                                }
                            }
                        }

                        return result;
                    }
                },
                {
                    Key: "StartDate",
                    Title: this.translate('draftEyp.date'),
                    SortField: "StartDate",
                    Content(i) {
                        return Vue.filter('datetime')(i.StartDate);
                    }
                },
                {
                    Key: "State",
                    Title: this.translate('jobFinalizer.state'),
                    SortField: "State",
                    Content(i) {
                        return Vue.filter('jobStatus')(i.State);
                    }
                },
            ]
        }
    },
    methods: {
        checkInput(value, event) {
            // Check for invalid characters
            if (/[<>]/.test(event.target.value)) {
                alert(this.translate('errors.invalidSymbols'))
                const editedText = ""
                this.$set(this.filterForm, value, editedText)
            } else {
                this.$set(this.filterForm, value, event.target.value)
            }
        },
        applyFilter(){
            var parts = [];

            if(this.filterForm.Number)
                parts.push(`TrackingNo.Number == ${this.filterForm.Number}`);

            if(this.filterForm.Title)
                parts.push(`Title.ToLower().Contains("${this.filterForm.Title.toLocaleLowerCase()}")`);

            if(this.filterForm.State)
                parts.push(`State == "${this.filterForm.State}"`);

            this.predicate = parts.join(" && ");
            console.log(this.predicate);

            this.$refs.jobList.predicate = this.predicate;
            this.$refs.jobList.getData();
            window.location.hash = '#' + this.baseFilterObject.ListType;
        }
    }
}
</script>